<div class="flex gap-col-20 gap-row-20 flex-wrap">
  @for (locationGroup of groupedLocations | keyvalue; track locationGroup.key) {
    <app-delivery-report-supply-chain-entity
      [locations]="locationGroup.value"
    ></app-delivery-report-supply-chain-entity>
  }
</div>
